import Vue from 'vue'
import Router from 'vue-router'

import { auth } from '@/plugins/firebase'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "trip" */ './views/Trips.vue')
    },
    {
      path: '/trips/new',
      name: 'trip-new',
      component: () => import(/* webpackChunkName: "trip" */ './views/trip/TripEdit.vue'),
      meta: { title: 'New Trip', parent: 'home' }
    },
    {
      path: '/trips/:id',
      component: () => import(/* webpackChunkName: "trip" */ './views/trip/Trip.vue'),
      // Trip Details route permissions are checked inside the component to
      // allow a not-authenticated user to view public trips
      meta: { title: 'Trip Details', allowAnonymous: true, parent: 'home' },
      children: [
        {
          path: '',
          name: 'trip',
          component: () => import(/* webpackChunkName: "trip" */ './views/trip/TripOverview.vue'),
          meta: { title: 'Trip Overview', parent: 'home' }
        },
        {
          path: 'map',
          name: 'trip-map',
          component: () => import(/* webpackChunkName: "trip" */ './views/trip/TripMapView.vue'),
          meta: { title: 'Trip Map', parent: 'trip' }
        },
        {
          path: 'gallery',
          name: 'trip-gallery',
          component: () => import(/* webpackChunkName: "trip" */ './views/trip/TripGallery.vue'),
          meta: { title: 'Trip Gallery', parent: 'trip' }
        }
      ]
    },
    {
      path: '/trips/:id/edit',
      name: 'trip-edit',
      component: () => import(/* webpackChunkName: "trip" */ './views/trip/TripEdit.vue'),
      meta: { title: 'Edit Trip', parent: 'trip' }
    },
    {
      path: '/signin',
      name: 'signin',
      component: () => import(/* webpackChunkName: "signin" */ './views/SignIn.vue'),
      meta: { title: 'Sign In', allowAnonymous: true }
    }
  ]
})

router.beforeEach(async (to, from, next) => {
  let title = to.meta.title

  if (title) {
    document.title = `${title} | Vjago`
  } else {
    document.title = 'Vjago'
  }

  if (to.matched.some(record => record.meta.allowAnonymous)) {
    // this route allows no auth or is the /login route
    next()
  } else {
    // By default all pages requires auth
    if (!auth.currentUser) {
      next({
        name: 'signin',
        query: { redirect: to.fullPath }
      })
    } else {
      // User logged in
      next()
    }
  }
})

export default router
